import ToggleSwitch from '@common/ToggleSwitch';
import React, { useEffect, useState } from 'react';
import * as HELPER from '@src/config/helper';
import { ROLE_FEATURES, STATUS_FIELD, STATUS_SUCCESS } from '@src/config/constant';
import { Financier, FinanciersTableProps, Pagination } from './financiers.interface';
import PaginationComponent from '@common/Pagination';
import AddEditFinancier from './AddEditFinancier';
import FinancierService from '@src/services/FinancierService';
import { toast } from 'react-toastify';

  
export default function FinanciersTable(props: FinanciersTableProps): ReturnType<React.FC> {
    let { apiResponse, loading, getFinanciersList, handleLoader} = props;
    let [tableData, setTableData] = useState<Financier[]>([]);
    let [showAddFinancier, setShowAddFinancier] = useState<boolean>(false);
    let [selectedFinancier, setSelectedFinancier] = useState<Financier>({ id: 0, name: '', status: STATUS_FIELD.ACTIVE, logo: '', ucf_financier_id: null })
    let [paginationData, setPaginationData] = useState<Pagination>({
        total: 0,
        limit: 10,
        pages: 0,
        cur_page: 1,
        prev_page: false,
        next_page: false,
    });
    let page = 1;
    let totalLengthWithoutPagination = 0;
    

    useEffect(() => {
        const { data, pagination } = apiResponse;
        if (apiResponse) {
            setTableData(data ?? [])
        }
                
        if (pagination) {
            setPaginationData(pagination);
        }

    }, [apiResponse])

    // Handles the click event for the edit button
    const handleEditBtnClick = (element: Financier) => {
        setSelectedFinancier(element);
        showModalAddFinancier();
    }

    // Handles the toggle switch action for a financier's status.
    const handleToggleSwitch = async (element: Financier) => {
        handleLoader(true);
        let formData = new FormData();
        formData.append('name', element.name.toString());
        formData.append('id', String(element.id));
        formData.append('status', element.status === 1 ? '0' : '1');
        const response = await FinancierService.addFinancier(formData);        
        if (response?.status === STATUS_SUCCESS) {
            //On a successful response, it updates the status and shows a success toast.
            toast.success("Status updated successfully");
            setSelectedFinancier({ ...selectedFinancier, status: element.status = element.status === 1 ? 0 : 1 });
        } else {
            //On failure, it reverts the status and shows an error toast.
            toast.error("Error updating status");
        }
        handleLoader(false);

    }

    /**
     * This function prepares the API parameters and calls the `getFinanciersList` function
     * to retrieve the list of financiers based on the provided page number.
     */
    const handleRequestData = (params: {page_no: number}) => {
        let apiParams = {
            page_number: params.page_no
        }
        getFinanciersList(apiParams)
    }

    const showModalAddFinancier = () => {
        setShowAddFinancier(showAddFinancier => !showAddFinancier);
    }


    return (
        <div>
            <div className="financer-table-list">

                <table>
                    <thead>
                        <tr>
                            <th>id</th>
                            <th>Financier Name</th>
                            <th>Logo</th>
                            <th>Status</th>
                            <th>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {tableData && tableData.map((element: Financier, indx) => {

                            return (
                                <tr key={indx}>
                                    <td>{element.id}</td>
                                    <td>{element.name}</td>
                                    <td>{element.logo && <img alt="" className="img-logo" src={element.logo ?? ''}/>}</td>
                                    <td>
                                        <div className="on-off-switch">
                                            <ToggleSwitch disabled={!HELPER.isUserHasAccessPage({permissionID: ROLE_FEATURES['insurance_partner_management'], accessType: 'edit'})} checked={element.status === 1 ? true : false} onChange={() => handleToggleSwitch(element)} />
                                        </div>
                                    </td>
                                    <td>
                                        <ul className='ulaction-btn'>
                                            <li title="Edit" onClick={() => { handleEditBtnClick(element) }}>
                                                <i className='ic-createmode_editedit' style={{ cursor: 'pointer' }}></i>
                                            </li>
                                        </ul>
                                    </td>

                                </tr>)
                        })}

                    </tbody>
                </table>

                <div className="pagination-outer">
                    {paginationData && paginationData.total ? <PaginationComponent
                        paginateData={{
                            page,
                            loading,
                            tableData: getFinanciersList,
                            totalLengthWithoutPagination,
                            paginationData,
                        }}
                        sendRequestDataToParent={handleRequestData}
                    /> : ''}
                </div>

            </div>
            <AddEditFinancier callFrom={'EditFinancier'} showAddFinancier={showAddFinancier} showModalAddFinancier={showModalAddFinancier}
                selectedFinancier={selectedFinancier} handleLoader={handleLoader} tableData={tableData} setTableData={setTableData}
                getFinanciersList={getFinanciersList}/>

        </div>
    )
}